const UI_ERROR_PATTERNS = [
  ["session_expired", /sess[aã]o expirada|token (?:inv[aá]lido|expirad)/i],
  ["driver_not_selected", /selecione.*motorista|motorista.*n[aã]o selecionad/i],
  ["driver_address_missing", /endere[cç]o.*motorista|motorista.*endere[cç]o/i],
  ["invalid_phone", /telefone|whatsapp|n[uú]mero.*(?:inv[aá]lid|incorret|ausente|n[aã]o cadastrad|n[aã]o est[aá])/i],
  ["required_or_missing_input", /obrigat[oó]ri|preencha|informe|selecione ao menos|selecione pelo menos/i],
  ["route_not_saved", /rota.*(?:salv|planejamento.*salv)/i],
  ["route_not_found", /rota.*n[aã]o (?:foi )?encontrad/i],
  ["route_pending", /aguard|pendente|continua.*processad|ainda.*processad/i],
  ["route_dispatch_failed", /n[aã]o.*(?:envi|dispar)|falh.*(?:envi|dispar)|erro.*(?:envi|dispar)/i],
  ["meta_not_ready", /meta cloud api.*n[aã]o est[aá] pronta|template.*n[aã]o.*pront/i],
  ["rate_limited", /muitas requisi[cç][oõ]es|rate.?limit/i],
  ["permission_denied", /acesso negado|sem permiss[aã]o|n[aã]o possui permiss[aã]o/i],
  ["network_failure", /load failed|failed to fetch|network|conex[aã]o/i],
  ["sgt_conflict", /sgt|diverg[eê]ncia/i],
  ["map_failure", /mapa|google directions/i],
  ["recipient_opt_out", /n[aã]o receber mensagens|opt.?out|descadastr/i],
];

export const stableFingerprint = (value) => {
  let hash = 2166136261;
  for (const char of String(value || "")) {
    hash ^= char.charCodeAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16).padStart(8, "0");
};

export const classifyUiError = (message, explicitCode = null) => {
  if (explicitCode) return String(explicitCode).trim().toLowerCase();
  const text = String(message || "").trim();
  const match = UI_ERROR_PATTERNS.find(([, pattern]) => pattern.test(text));
  return match?.[0] || "unclassified_ui_error";
};

export const safeDescription = (value) => String(value || "")
  .replace(/https?:\/\/\S+/gi, "[link]")
  .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, "[email]")
  .replace(/\b(?:\d[\s().-]?){8,}\d\b/g, "[numero]")
  .trim()
  .slice(0, 300);

export const safeUiMessage = (value) => String(value || "")
  .split(/\r?\n/, 1)[0]
  .replace(/https?:\/\/\S+/gi, "[link]")
  .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, "[email]")
  .replace(/\b(?:\d[\s()./-]?){5,}\d\b/g, "[numero]")
  .replace(/\b(?:token|senha|authorization)\s*[:=]\s*\S+/gi, "$1=[redacted]")
  .trim()
  .slice(0, 220);

const safeUrl = (value) => {
  try {
    const parsed = new URL(String(value), "https://rotaflex.invalid");
    const path = parsed.pathname.replace(/\/\d+(?=\/|$)/g, "/:id");
    if (parsed.origin === "https://rotaflex.invalid") return path;
    return `${parsed.origin}${path}`;
  } catch {
    return "[url]";
  }
};

export const sanitizeSentryBreadcrumb = (breadcrumb) => {
  if (!breadcrumb || typeof breadcrumb !== "object") return breadcrumb;
  const category = String(breadcrumb.category || "");

  // console.log é muito fácil de receber payloads inteiros, nomes e telefones.
  // Os eventos explícitos abaixo substituem essa fonte sem carregar PII.
  if (category === "console") return null;

  if (category === "ui.click") {
    return {
      ...breadcrumb,
      message: "ui_click",
      data: undefined,
    };
  }

  if (["fetch", "xhr", "http"].includes(category)) {
    const data = breadcrumb.data || {};
    return {
      ...breadcrumb,
      message: safeUiMessage(breadcrumb.message),
      data: {
        ...(data.method ? { method: String(data.method).slice(0, 12) } : {}),
        ...(data.status_code != null ? { status_code: data.status_code } : {}),
        ...(data.url ? { url: safeUrl(data.url) } : {}),
      },
    };
  }

  if (category === "navigation") {
    const data = breadcrumb.data || {};
    return {
      ...breadcrumb,
      data: {
        ...(data.from ? { from: safeUrl(data.from) } : {}),
        ...(data.to ? { to: safeUrl(data.to) } : {}),
      },
    };
  }

  return breadcrumb;
};

// Defesa adicional: nunca enviar query/fragmento de links de acesso, corpos de
// requisição ou headers de autenticação ao monitoramento do navegador.
export const sanitizeSentryEvent = (event) => {
  if (!event?.request) return event;
  return { ...event, request: {
    ...(event.request.method ? { method: event.request.method } : {}),
    ...(event.request.url ? { url: safeUrl(event.request.url) } : {}),
  } };
};
